var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0696 9.36818C17.0699 8.94869 17.4894 7.75477 17.0376 6.78672L15.4565 3.4631C15.0047 2.52764 13.9076 2.10783 12.9396 2.52764C10.1968 3.6893 7.84118 5.2059 5.96962 7.04519C3.67858 9.20684 2.1297 11.6915 1.29073 14.4343C0.451755 17.2097 0 20.9847 0 25.7927V35.699C0 36.7639 0.871242 37.6351 1.93609 37.6351H14.6175C15.6824 37.6351 16.5536 36.7639 16.5536 35.699V23.0176C16.5536 21.9525 15.6824 21.0815 14.6175 21.0815H8.55108C8.61561 17.8221 9.39005 15.2087 10.8099 13.24C11.9715 11.6595 13.714 10.3688 16.0696 9.36818Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8508 9.368C39.8511 8.94851 40.2703 7.75459 39.8188 6.78654L38.2377 3.4955C37.7859 2.55973 36.6888 2.14024 35.7208 2.55973C33.0102 3.72138 30.6866 5.23799 28.7831 7.04501C26.4917 9.23925 24.9109 11.7239 24.0716 14.4667C23.2326 17.1769 22.8135 20.9526 22.8135 25.7928V35.6992C22.8135 36.764 23.6847 37.6353 24.7496 37.6353H37.431C38.4958 37.6353 39.3671 36.764 39.3671 35.6992V23.0178C39.3671 21.9526 38.4958 21.0817 37.431 21.0817H31.3323C31.3968 17.8223 32.1716 15.2089 33.5911 13.2402C34.7527 11.6594 36.4952 10.3686 38.8508 9.368Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftQuote);
export default __webpack_public_path__ + "static/media/left-quote.3a37a6ad63e40fa8cb098af92e94be3d.svg";
export { ForwardRef as ReactComponent };